import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseWidget, NgGridStackWidget } from 'gridstack/dist/angular';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { IColumnDefinition } from '../standard-tile.model';

@Component({
  selector: 'tt-vehicle-info-item-combo',
  standalone: true,
  imports: [CommonModule, FormsModule, NzSelectModule],
  templateUrl: './tile-info-item-combo.component.html',
  styleUrl: './tile-info-item-combo.component.scss'
})
export class TileInfoItemComboComponent extends BaseWidget {
  @Input() cardConfig?: any;
  @Input() columnDefinition?: IColumnDefinition[];
  selectedProp1?: IColumnDefinition;
  selectedProp2?: IColumnDefinition;

  compareFn = (i1: any, i2: any) => {
    if (i1 && i2) {
      return i1.field === i2.field;
    }
    return false;
  };

  override deserialize(w: NgGridStackWidget): void {
    super.deserialize(w);
    this.selectedProp1 = this.cardConfig
      ? this.columnDefinition?.find(el => el.field === this.cardConfig.prop)
      : undefined;
    this.selectedProp2 = this.cardConfig
      ? this.columnDefinition?.find(el => el.field === this.cardConfig.prop2)
      : undefined;
  }

  setProp() {
    Object.assign(this.widgetItem!.input!, { cardConfig: { prop: this.selectedProp1?.field, prop2: this.selectedProp2?.field } });
  }

}
